<h2 mat-dialog-title class="dialog-header">
  <button mat-icon-button class="close-btn" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="dialog-content">
  <app-admin-sender [data]="data?.uuid"></app-admin-sender>
</mat-dialog-content>
